/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntegrationUpdateEventCategoryPayload = {
    name?: string;
    description?: string | null;
    color?: string;
    price?: string;
    location?: IntegrationUpdateEventCategoryPayload.location;
    publicBookingEnabled?: boolean;
    privateBookingEnabled?: boolean;
    outageFeeEnabled?: boolean;
};
export namespace IntegrationUpdateEventCategoryPayload {
    export enum location {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
        NOT_FIXED = 'not-fixed',
    }
}

